import createApi from '@/utils/api.js'
import base from './base.json'
import publicApi from './public'
import news from './cms/news'
import file from './cms/file'
import help from './cms/help'
import notice from './cms/notice'
import ad from './cms/ad'
import priceFixed from './cms/priceFixed'
import element from './cms/element.js'
import sys from './sys'
import member from './member'
import category from './tender/category'
import audit from './tender/audit'
import bid from './tender/bid'
import add from './tender/add'
import about from './cms/about'
import param from './cms/param'
import label from './cms/label'
import { brand, units, attr, pmCategory } from './pm'
import self from './self'
import floor from './cms/floor'
import productSta from './sa/productSta'
import merchant from './sa/merchant'
import feedback from './feedback'
import activity from './pam'
import omHome from './home/om'
import tenderSupport from './tender/support'
import admin from './admin/admin'
import fund from './fund'
import business from './business'
import wxpay from './wechat/wxpay'
import version from './app'
import integral from './integral'

/**
 * @description 当初设计的时候没有考虑到模块，所以会很恶心
 */

export default createApi({
  omHome,
  base,
  public: publicApi,
  news,
  help,
  notice,
  file,
  ad,
  priceFixed,
  element,
  role: sys.role,
  function: sys.fun,
  funMenu: sys.funMenu,
  user: sys.user,
  sysLog: sys.operateLog,
  common: sys.common,
  organization: sys.organization, //系统管理-组织机构
  crmMember: member.memberQuery,
  memberExit: member.memberExit,
  memberIintegral: member.integral,
  orgMember: member.orgMember,
  memberAnalyse: member.statistics,
  orgAnalysis: member.orgAnalysis,
  wallet: member.wallet,
  bank: member.bank,
  sys: sys.sys,
  feedback,
  category,
  audit,
  bid,
  add,
  about,
  label,
  brand,
  units,
  attr,
  pmCategory,
  param,
  floor,
  productSta,
  merchant,
  tenderSupport,
  wxpay,
  version,
  integralDetail: integral.detail,
  integralEquip: integral.equip,
  jc_tong: member.jcTong,
  activityData: activity.statistical,
  activityManage: activity.activity,
  businessReview: business.review,
  // 自营模块 start
  selfPmList: self.pm.list,
  selfPurchase: self.purchase, // 采购管理
  selfPurPayment: self.payment, // 付款管理
  selfOrderList: self.order.list,
  selfReceiptOrder: self.order.receiptOrder, // 送货单列表
  selfOrderImport: self.order.imp, // 订单导入（旧）
  selfOrderImportOrder: self.order.importOrder, // 订单导入
  selfOrderReplace: self.order.replace,
  selfOrderReceipt: self.order.receipt,
  selfOrderDzd: self.order.dzd, // 对账单
  // selfPurchaseServe: self.purchase.serve,//服务单查询
  selfStore: self.store,
  selfPrint: self.print,
  selfBusSales: self.sales.business, // 业务销售
  selfCustomer: self.sales.customer, // 客户管理
  selfStatementList: self.statement.list,
  selfPayment: self.sales.payment, // 到账
  selfStatisticsSales: self.statistics.sales, // 销售统计
  selfStatisticsProd: self.statistics.product, // 商品统计
  selfStatisticsPurchase: self.statistics.purchase, // 采购统计
  selfStatisticsFinance: self.statistics.finance, // 财务统计
  selfStatisticsFinanceCollect: self.statistics.collect, // 财务统计——汇总统计（新
  selfStatisticsOperation: self.statistics.operation, // 运营统计
  selfCenPurchase: self.cenPurchase, // 集采需求
  selfCurAccount: self.account, // 应收款流水
  selfScreen: self.screen, // 自营大屏数据
  secondary: self.secondhand,
  area: self.area,
  selfReport: self.report, // 报表统计
  selfInformationSupplier: self.information.supplier, // 基础资料-供应商管理
  selfInformationCustomer: self.information.customer, // 基础资料-供应商管理
  selfInformationProject: self.information.project, // 基础资料-供应商管理
  selfPushOrder: self.pushOrder.pushHistory,
  selfPushRecord: self.pushOrder.pushRecord,
  selfPushSettings: self.pushOrder.pushSettings,
  selfInputInvoice: self.inputInvoice.purchase,
  selfInputInvoiceManagement: self.inputInvoice.management,
  //销项发票
  selfOutputInvoiceUnbilled: self.outputInvoice.unbilled,
  selfSalesContractsList: self.salesContracts.list,
  selfOutputInvoiceManagement: self.outputInvoice.management,
  selfOutputInvoiceRegistration: self.outputInvoice.registration,
  selfOutputInvoiceApply: self.outputInvoice.apply,
  // 收款管理
  selfStatementReceive: self.statement.receive,
  // 付款管理
  selfStatementPayment: self.statement.payment,
  // 冲销项目收款
  selfStatementReceipt: self.statement.receipt,
  // 自营模块 end
  admin,
  fund // 资金管理
})



// WEBPACK FOOTER //
// ./src/api/apis/index.js